module.exports = __webpack_public_path__ + "static/media/fruit-apple-3.ebceb251.png";